export function getRedirectPath(params: URLSearchParams): string | null {
  const redirect = params.get("redirect");
  if (
    !redirect ||
    !redirect.startsWith("/") ||
    redirect.startsWith("//") ||
    redirect.includes("://") ||
    redirect.includes("\\")
  ) {
    if (redirect) {
      console.error("Unsafe redirect path rejected:", redirect);
    }
    return null;
  }
  return redirect;
}

export function getCallbackURL(params: URLSearchParams): string | undefined {
  const redirectPath = getRedirectPath(params);
  if (!redirectPath) return undefined;
  return import.meta.env.VITE_WEB_APP_URL + redirectPath;
}
